import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';
import { ReadinessResponse } from 'src/app/models/income-wizard-workflow';
import { RiqAlertComponent } from 'src/app/shared-components-module/riq-alert/riq-alert.component';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';

@Component({
  selector: 'app-wizard-readiness-phase',
  templateUrl: './wizard-readiness-phase.component.html',
  styleUrls: ['./wizard-readiness-phase.component.less'],
})
export class WizardReadinessPhaseComponent implements OnInit {
  @Input() screeningId!: number;
  @Input() disabled = false;
  @Output() phaseComplete = new EventEmitter<void>();
  //When readiness is blocked and user cannot override, parent should dismiss the wizard modal.
  @Output() closeRequested = new EventEmitter<void>();

  loadingReadiness = true;
  loadError: string | null = null;
  overrideError: string | null = null;
  overrideBusy = false;
  readiness: ReadinessResponse | null = null;

  constructor(private appData: ApplicantDataService, private modal: NgbModal) {}

  ngOnInit(): void {
    this.fetchReadiness();
  }

  fetchReadiness(): void {
    if (this.screeningId == null || Number.isNaN(Number(this.screeningId))) {
      this.loadingReadiness = false;
      this.loadError = 'Missing ScreeningID.';
      return;
    }

    this.loadingReadiness = true;
    this.loadError = null;
    this.overrideError = null;

    this.appData.checkReadiness(this.screeningId).subscribe({
      next: (r) => {
        this.readiness = r;
        this.loadingReadiness = false;
      },
      error: (err: unknown) => {
        this.loadingReadiness = false;
        this.loadError = this.readinessHttpErrorMessage(err);
      },
    });
  }

  onContinueIfReady(): void {
    if (this.disabled || !this.readiness?.isReady) {
      return;
    }
    this.phaseComplete.emit();
  }

  onCloseNotReady(): void {
    if (this.disabled) {
      return;
    }
    this.closeRequested.emit();
  }

  onOverrideReadiness(): void {
    if (this.disabled || !this.readiness?.canOverride || this.readiness.isReady || this.overrideBusy) {
      return;
    }
 
    // Create the wizard state with override flag — no separate override endpoint needed.
    this.appData.startOrResumeWizard(this.screeningId, { overrodeReadiness: true }).subscribe({
      next: () => {
        this.overrideBusy = false;
        this.phaseComplete.emit();
      },
      error: (err: unknown) => {
        this.overrideBusy = false;
        this.overrideError = this.readinessHttpErrorMessage(err) || 'Could not override readiness.';
      },
    });
  }

  private readinessHttpErrorMessage(err: unknown): string {
    if (err instanceof HttpErrorResponse) {
      const body = err.error;
      if (
        body &&
        typeof body === 'object' &&
        'response' in body &&
        typeof (body as { response?: unknown }).response === 'string'
      ) {
        return (body as { response: string }).response;
      }
      return err.message || 'Could not load readiness.';
    }
    return 'Could not load readiness.';
  }
}
